const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const getRoles = async () => {
    const token = localStorage.getItem('token');
    try {
        const response = await fetch(`${API_BASE_URL}/admin/user/roles`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });


        if (!response.ok) {
            const errorData = await response.json();
            console.error('Ошибка при получении списка ролей:', errorData);
            throw new Error(errorData.message || `Ошибка получения ролей. Статус: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Ошибка сети при получении списка ролей:', error);
        throw error;
    }
};